import * as React from 'react'
import styles from './style.module.css';
import {isEmpty} from "lodash";
import IconProvider from '../../../design-system/lib/IconProvider';
import Typography from '../../../design-system/lib/Typography';
import { CLOSE, Edit, LOCATION, Speaker, Speakermegaphone } from '../../../assets';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '../../../design-system/lib/Button';
 import Input from '../../../design-system/lib/Input';
import Modal from '../../../design-system/lib/Modal';
import clsx from 'clsx';
import { DispatcherApi } from '../../../service/API/dispatcher';
import { get_id } from '../../../helper/UserData/userdate';




function DispatcherHomeMessage({data , onclick}) {
    const { t } = useTranslation();
    const Globalsettings = useSelector((state) => state.SharedData.settings);
  const [dialoge, setDialoge] = React.useState(false);
  const [value, setValue] = React.useState(Globalsettings.dispatcherHomeMessage);
  const [ripple, setRipple] = React.useState(false);

  

    
          React.useEffect(() => {
                      setValue(Globalsettings.dispatcherHomeMessage)

         try {
             document.addEventListener('DispatcherHomeMessage', (e) => {
            
              setRipple(true);
              setValue(Globalsettings.dispatcherHomeMessage)

              setTimeout(() => {
                              setRipple(false);

              }, 1200);
                    //         console.log("stopUpdated -> dispatcher:stop:updated ",e.detail.stopId);

             })
             return () => {
               document.removeEventListener("DispatcherHomeMessage",()=>{
                 
               });
           };
         } catch (error) {
          
         }
          }, [Globalsettings])


            const ConfirmationOnClick = React.useCallback(async(id) => {
              let Dispatcher = new DispatcherApi()
              let dataP = await Dispatcher.HomeMessage(get_id() , value)
              setDialoge(false)
              setValue(value)
 
 
          
            }, [value]);

   return (
    <>
       <div className={clsx(styles.helloMessageContainer ,ripple && styles.active)}>
          <IconProvider Icon={ripple ? Speakermegaphone : Speaker} />
          <Typography weight="Body_Middle_Regular" textColor="TextDark" text={Globalsettings.dispatcherHomeMessage} />
          {!ripple && <Button onClick={()=>{setDialoge(true)}} size='Small' type='Secondary' icon={Edit} iconSize={"14"} style={{position:"absolute" ,gap:"2px", right:"0px" ,
            color :"rgba(16, 128, 255, 1)" , backgroundColor:"transparent" ,fontWeight:"400",marginInlineEnd:"6px"}} text={t("Edit")}/>}
        </div>


         {dialoge && <Modal bodyStyle={{backgroundColor:"transparent"}} ConfirmationDisabled={isEmpty(value)} 
         ConfirmationOnClick={ConfirmationOnClick} onclose={() => { setDialoge(false) }} size='large' icon={CLOSE} title={t("Home message")}
          body={<div> <Input  type={dialoge.inputType} placeHolder={t("Enter Text")} value={value} onChange={(e) => {
        // setDialoge({
        //   ...dialoge,
        //   inputValue: e.target.value
        // })
        setValue(e.target.value || "")
      }} /> </div>} ConfirmationText={t("save")}   />}
      </>

  )
}

export default DispatcherHomeMessage